import { gql } from "@apollo/client";

export const SERVICES_MUTATION = gql`
mutation CreateGig($serviceCategoryId: Int!, $title: String!, $description: String!, $price: Int!, $deliveryTime: String!, $requirement: String!, $tags: [String!],$portfolio:[String]) {
    createGig(serviceCategoryId: $serviceCategoryId, title: $title, description: $description, price: $price, deliveryTime: $deliveryTime, requirement: $requirement, tags: $tags,portfolio:$portfolio) {
      id
    }
}`

